/**
 * URL Encode Command
 * Encode URL components or full URLs
 */
import { Command } from 'commander';
import { UtilsService } from '../../services/utils.service.js';

async function handleUrlEncode(
    input: string,
    options: {
        full: boolean;
    }
): Promise<void> {
    const service = new UtilsService();

    try {
        const encoded = service.urlEncode(input, options.full);

        console.log('🔗 URL Encoded:');
        console.log('────────────────────────────────────────');
        if (options.full) {
            console.log('   Mode: Full URL (encodeURI)');
        } else {
            console.log('   Mode: Component (encodeURIComponent)');
        }
        console.log();
        console.log(`   ${encoded}`);
        console.log();
    } catch (error) {
        console.error('❌ Error:', error instanceof Error ? error.message : String(error));
        process.exit(1);
    }
}

export function createUrlEncodeCommand(): Command {
    const cmd = new Command('url-encode')
        .description('Encode URL component or full URL')
        .argument('<input>', 'Text to encode')
        .option('--full', 'Encode full URL (use encodeURI instead of encodeURIComponent)')
        .addHelpText('after', `
Examples:
  $ jai1 utils url-encode "hello world"
  $ jai1 utils url-encode "hello world & test"
  $ jai1 utils url-encode "name=John Doe&age=30"
  $ jai1 utils url-encode "https://example.com/path with spaces" --full
`)
        .showHelpAfterError('(add --help for additional examples)')
        .action(async (input, options) => {
            await handleUrlEncode(input, options);
        });

    return cmd;
}
